<script setup>
import WorkflowAutomationWizard from "@/components/workflow-automations/WorkflowAutomationWizard.vue";
import axios from "@/utils/axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useRouter } from "vue-router";
import { useLoading } from "vue-loading-overlay";
import loaderData from "@/utils/loader-data";

const router = useRouter();
const $loading = useLoading(loaderData);

const saveAutomation = (payload) => {
  let loader = $loading.show();
  axios
    .post("/workflow_automations", payload)
    .then((response) => {
      if (response.status === "success") {
        toast.success(response.message, { autoClose: 3000 });
        router.push({ name: "workflow-automations-list" });
      } else {
        toast.error(response.message, { autoClose: 2000 });
      }
    })
    .catch(() => {
      toast.error("Failed to create workflow automation", { autoClose: 2000 });
    })
    .finally(() => loader.hide());
};

const discardChanges = () => {
  router.push({ name: "workflow-automations-list" });
};

definePage({ meta: { requiresAuth: true } });
</script>

<template>
  <div>
    <WorkflowAutomationWizard
      submit-label="Create Automation"
      @save="saveAutomation"
      @cancel="discardChanges"
    />
  </div>
</template>
